import { UserProfile } from '@texas/api/endpoints/userProfilesApi';

export function findOptionFromProfiles(id: any, profiles: UserProfile[]) {
  const profile = profiles.find((k) => k.id === id);
  if (!profile) return undefined;
  return convertToOption(profile);
}

export function convertToOption(profile: UserProfile) {
  return {
    value: profile.id,
    label: profile.name,
  };
}

export function findCountry(
  code: string | null,
  countries: { name: string; code: string }[],
) {
  const country = countries.find((c) => c.code === code);
  if (country)
    return {
      label: `${country.name} (${country.code})`,
      value: country.code,
    };

  return undefined;
}
